import React from 'react'
import PortfolioSections from './PortfolioSections'

export default function PagePortfolioList() {
    return (
        <>
            <div className="section">
                <div className="container">
                    <PortfolioSections />
                </div>
            </div>
        </>
    )
}
